let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("id7Wf")).then(() => parcelRequire('ej18y'));